export default {
    setCaptchaImage(state, payload) {
        state.id = payload.captchaId;
        state.imageString = payload.sourceString;
    }
}